import React, { useState, useEffect } from 'react'
import { CiCalendarDate } from 'react-icons/ci'
import { FaRegUser } from 'react-icons/fa'
import { GoClock } from 'react-icons/go'
import { Loading } from '../components/Loading'
import * as api from '../utils/api/apiClient'
import { toast } from 'react-toastify'

const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-lg shadow-md ${className}`}>{children}</div>
)

const Home = () => {
  const [loading, setLoading] = useState(false) // Manage loading state
  const [dashboardData, setDashboardData] = useState({})

  const UpcomingLeaveCount = dashboardData?.upcoming_holidays?.length || 0

  // get all attendance function
  const fetchDashboard = async () => {
    try {
      const res = await api.getDashBoard()
      setDashboardData(res.data)
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }

  useEffect(() => {
    fetchDashboard()
    setTimeout(() => {
      setLoading(true)
    }, 400) // 5 seconds
  }, [])
  return (
    <>
      {!loading && <Loading />}
      <div className='p-4 space-y-4 bg-cream min-h-screen'>
        {/* Header */}
        <h1 className='text-2xl font-bold mb-6 text-black'>
          Employee Attendance Dashboard
        </h1>

        {/* Stats Cards */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-4'>
          <Card>
            <div className='p-4'>
              <div className='flex items-center space-x-4'>
                <FaRegUser className='h-8 w-8 text-link' />
                <div>
                  <p className='text-sm text-brown'>Total Employees</p>
                  <p className='text-2xl font-bold text-black'>
                    {dashboardData.total_employees}
                  </p>
                </div>
              </div>
            </div>
          </Card>

          <Card>
            <div className='p-4'>
              <div className='flex items-center space-x-4'>
                <GoClock className='h-8 w-8 text-muted_green' />
                <div>
                  <p className='text-sm text-brown'>Present Today</p>
                  <p className='text-2xl font-bold text-black'>
                    {dashboardData.present_today}
                  </p>
                </div>
              </div>
            </div>
          </Card>

          <Card>
            <div className='p-4'>
              <div className='flex items-center space-x-4'>
                <CiCalendarDate className='h-8 w-8 text-rust' />
                <div>
                  <p className='text-sm text-brown'>On Leave</p>
                  <p className='text-2xl font-bold text-black'>
                    {dashboardData.on_leave}
                  </p>
                </div>
              </div>
            </div>
          </Card>

          <Card>
            <div className='p-4'>
              <div className='flex items-center space-x-4'>
                <CiCalendarDate className='h-8 w-8 text-gold' />
                <div>
                  <p className='text-sm text-brown'>Upcoming Holidays</p>
                  <p className='text-2xl font-bold text-black'>
                    {UpcomingLeaveCount}
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Recent Attendance & Holidays */}
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <Card>
            <div className='p-4'>
              <h2 className='text-xl font-bold mb-4 text-black'>
                Recent Attendance
              </h2>
              <div className='space-y-4'>
                {dashboardData?.recent_attendances?.map((entry, index) => (
                  <div
                    key={index}
                    className='flex items-center justify-between border-b border-light_gray pb-2'
                  >
                    <div>
                      <p className='font-medium text-black'>
                        {entry.employee_name}
                      </p>
                      <p className='text-sm text-brown'>
                        {new Date(entry.time).toLocaleDateString()}{' '}
                        {new Date(entry.time).toLocaleTimeString([], {
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </p>
                    </div>
                    {/* <span
                      className={`px-2 py-1 rounded-full text-sm ${
                        entry.status === 'Present'
                          ? 'bg-muted_green text-white'
                          : 'bg-rust text-white'
                      }`}
                    >
                      {entry.status}
                    </span> */}
                  </div>
                ))}
              </div>
            </div>
          </Card>

          <Card>
            <div className='p-4'>
              <h2 className='text-xl font-bold mb-4 text-black'>
                Upcoming Holidays
              </h2>
              <div className='space-y-4'>
                {dashboardData?.upcoming_holidays?.map((holiday, index) => (
                  <div
                    key={index}
                    className='flex items-center justify-between border-b border-light_gray pb-2'
                  >
                    <p className='font-medium text-black'>{holiday.name}</p>
                    <p className='text-sm text-brown'>
                      {new Date(holiday.date).toLocaleDateString()}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

export default Home
